import fetch from './api'
import global_ from "../global/index"
let data = { appsystem: "h5", app_id: "1" };

// 获取学习包目录
const GETCATALOG = params => {
    return fetch({
        url: "/api/v2/course/package/catalog",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取课程配套
const GETMAP = params => {
    return fetch({
        url: "/api/v2/course/map",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取防盗链视频播放地址
const GETMEDIA = params => {
    return fetch({
        url: "/api/v2/course/h5/media",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取直播日历
const GETCALENDAR = params => {
    return fetch({
        url: "/api/v2/home/calendar",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 课程详情直播列表
const COURSELIVE = params => {
    return fetch({
        url: "/api/v2/course/live",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取学习记录
const LEARNGET = params => {
    return fetch({
        url: "/api/v1/course/learn/get",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取最近一条学习记录
const LASTSTUDYRECORD = params => {
    return fetch({
        url: "/api/v2/home/laststudyrecord",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 获取优惠券列表
const GETCOUPON = params => {
    return fetch({
        url: "/api/v2/coupon/list",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 优惠券兑换
const CHANGECOUPON = params => {
    return fetch({
        url: "/api/v2/coupon/change",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 优惠券商品列表
const GOODSLIST = params => {
    return fetch({
        url: "/api/v3/coupon/goods/list",
        method: "get",
        params: Object.assign(data, params)
    });
};

// 校验会员
const CHECKMEMBER = params => {
    return fetch({
        url: "/api/v3/check/member",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告
const STUDYREPORT = params => {
    return fetch({
        url: "/api/v2/studyreport/report/detail",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告直播列表
const LIVELIST = params => {
    return fetch({
        url: "/api/v2/studyreport/live/list",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告
const COURSEDETAIL = params => {
    return fetch({
        url: "/api/v2/studyreport/course/detail",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告直播列表
const COURSELIVELIST = params => {
    return fetch({
        url: "/api/v2/course/live/list",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告视频列表
const VIDEOLIST = params => {
    return fetch({
        url: "/api/v2/course/video/list",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告作业列表
const HOMEWORKLIST = params => {
    return fetch({
        url: "/api/v2/course/homework/list",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 加群提醒记录
const ADDGROUPREMIND = params => {
    return fetch({
        url: "/api/v2/user/addGroupRemind",
        method: "get",
        params: Object.assign(data, params)
    });
};

// 学习概览
const OVERVIEW = params => {
    return fetch({
        url: "/api/v2/studyreport/overview",
        method: "post",
        data: Object.assign(data, params)
    });
};

// 学习报告切换
const IDS = params => {
    return fetch({
        url: "/api/v2/studyreport/ids",
        method: "post",
        data: Object.assign(data, params)
    });
};

const CheckRoomState = params => {
  return fetch({
    url: "/api/v3/course/checkRoomState",
    method: "post",
    data: Object.assign(data, params)
});
}

export default {
    GETCATALOG,
    GETMAP,
    GETMEDIA,
    GETCALENDAR,
    COURSELIVE,
    LEARNGET,
    LASTSTUDYRECORD,
    GETCOUPON,
    CHANGECOUPON,
    GOODSLIST,
    CHECKMEMBER,
    STUDYREPORT,
    LIVELIST,
    COURSEDETAIL,
    COURSELIVELIST,
    VIDEOLIST,
    HOMEWORKLIST,
    ADDGROUPREMIND,
    OVERVIEW,
    IDS,
    CheckRoomState
}



// WEBPACK FOOTER //
// ./src/api/interface-user.js